var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImtoken(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "imtokenGradient",
    x1: "97.204%",
    x2: "0%",
    y1: "2.796%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#11C4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0062AD"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#imtokenGradient)",
    d: "M23.915.624c.791 10.714-6.096 15.778-12.27 16.318C5.905 17.444.502 13.917.028 8.498c-.391-4.477 2.376-6.383 4.55-6.573 2.236-.196 4.115 1.346 4.278 3.213.157 1.795-.963 2.612-1.742 2.68-.616.054-1.391-.32-1.461-1.123-.06-.69.202-.784.138-1.517-.114-1.305-1.252-1.457-1.875-1.403-.754.066-2.122.946-1.93 3.138.193 2.211 2.313 3.958 5.092 3.715 2.999-.262 5.087-2.597 5.244-5.872a1.19 1.19 0 0 1 .107-.503l.001-.004a1.411 1.411 0 0 1 .113-.197c.064-.096.146-.202.252-.318.001-.003.001-.003.003-.003.077-.087.17-.181.275-.282 1.31-1.236 6.028-4.151 10.49-3.228a.447.447 0 0 1 .352.403",
    transform: "translate(0 .5)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImtoken);
export default __webpack_public_path__ + "static/media/imtoken.7c1004e5.svg";
export { ForwardRef as ReactComponent };